import React, { useRef } from "react";
import { AUDIO_FILE_ACCEPT } from "../utils/supportedAudioFormats";

const DragDropArea = ({ onFileDrop, isDragging }) => {
  const fileInputRef = useRef(null);

  const handleAreaClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      onFileDrop(files);
    }
  };

  const areaStyle = {
    border: `2px dashed ${isDragging ? "#007bff" : "#ccc"}`,
    borderRadius: "10px",
    backgroundColor: isDragging ? "#e6f7ff" : "#fafafa",
    padding: "50px",
    textAlign: "center",
    cursor: "pointer",
    transition: "all 0.3s ease",
    marginTop: "20px",
    maxWidth: "800px",
    margin: "20px auto",
  };

  return (
    <div style={areaStyle} onClick={handleAreaClick}>
      <input
        id="cac-audio-file-input"
        name="cac-audio-files"
        type="file"
        multiple
        ref={fileInputRef}
        onChange={handleFileChange}
        style={{ display: "none" }}
        accept={AUDIO_FILE_ACCEPT}
      />
      <p style={{ margin: 0, fontSize: "1.2rem" }}>
        ここに音声ファイルをドラッグ＆ドロップ
      </p>
      <p style={{ margin: "10px 0 0", color: "#666" }}>
        またはクリックしてファイルを選択
      </p>
    </div>
  );
};

export default DragDropArea;

//DragDropArea.js
